import React from "react";

const items = [
  "DLG Counseling & Consulting",
  "Online Telehealth · California",
  "Couples · Family · Individual",
  "Licensed MFT",
  "Free 15-min Consultation",
];

export default function Marquee() {
  const line = items.join("  ·  ") + "  ·  ";
  return (
    <section
      data-testid="marquee"
      className="relative overflow-hidden border-y border-[#D5D1C9] bg-[#EFECE5] py-6"
      aria-hidden
    >
      <div className="marquee-track flex whitespace-nowrap will-change-transform">
        {Array.from({ length: 6 }).map((_, i) => (
          <span
            key={i}
            className="font-serif-display italic text-[10vw] sm:text-[7vw] leading-none text-[#1A1A18] pr-14"
          >
            {line}
          </span>
        ))}
      </div>
    </section>
  );
}
